import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import Sidebar from "@/components/layout/Sidebar.vue";
import { useDisableScrollbarsOnBody } from "@/composables/screen";
import Projects from "@/views/dashboard/components/Projects.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'Home',
  setup(__props) {

useDisableScrollbarsOnBody();

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(Sidebar, { isHome: "" }, {
    default: _withCtx(() => [
      _createVNode(Projects)
    ]),
    _: 1
  }))
}
}

})